import { Injectable } from '@angular/core';
import { ApiResponseConvertor } from '@app/shared/utils/api-response-convertor.interface';
import { DocumentSubType } from './document-subtype.interface';

export class DocumentType {
    constructor(
        public id: number,
        public name: string,
        public subTypes: DocumentSubType[]
    ) { }
}
@Injectable({
    providedIn: 'root',
})
export class DocumentTypeConverter implements ApiResponseConvertor<DocumentType> {
    convert(item: any): DocumentType {
        return new DocumentType(item.id, item.name, item.documentSubTypes);
    }
}
